import { jsx as o, jsxs as t } from "react/jsx-runtime";
import e from "../../assets/icons/ProductHeartSymbol.js";
import i from "../../assets/icons/ProduceOfFinlandSymbol.js";
import a from "../../assets/icons/KeyFlagSymbol.js";
import b from "../../assets/icons/EuEcoLabel.js";
import s from "../../assets/icons/PuhtaastiKotimainenSirkkalehtiSymbol.js";
import n from "../../assets/icons/NordicSwanEcoLabelSymbol.js";
import c from "../../assets/icons/FairtradeMarkSymbol.js";
import "react";
import { useTranslation as A } from "../../hooks/useTranslation.js";
import "../Context/index.js";
import { AccessibleIcon as l } from "../Icon/index.js";
import "../IconButton/index.js";
import "../../pagination-BeOG0tbT.js";
import "../ProductTable/TableRowGroup.js";
import { Popover as E } from "../Popover/index.js";
import "../../types/apiSchema.js";
import "../../types/localizationSchema.js";
import I from "../../assets/icons/RainforestAllianceSymbol.js";
import { EuOrganicSymbol as _ } from "../../assets/icons/EuOrganicSymbol.js";
import { EuOrganicSymbolWithLabel as N } from "../../assets/icons/EuOrganicSymbolWithLabel.js";
const m = () => {
  const { t: r } = A();
  return /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(
    E,
    {
      ariaLabel: r("RAINFOREST_ALLIANCE_ICON"),
      ariaLabelClose: r("close"),
      content: /* @__PURE__ */ t("div", { style: { fontSize: "0.75rem" }, children: [
        r("RAINFOREST_ALLIANCE_INFO"),
        " ",
        /* @__PURE__ */ o("a", { href: "https://www.rainforest-alliance.org/", target: "_blank", children: "https://www.rainforest-alliance.org/" })
      ] }),
      placement: "bottom",
      children: /* @__PURE__ */ o(l, { svgIcon: /* @__PURE__ */ o(I, {}), label: "" })
    }
  ) });
}, U = {
  "FREE_FROM-LACTOSE": { symbol: "L", color: "#0076CA" },
  "FREE_FROM-GLUTEN": { symbol: "G", color: "#f09f55" },
  "FREE_FROM-MILK": {
    symbol: "M",
    color: "white",
    borderColor: "black",
    textColor: "black"
  },
  "HIGH-FIBRE": { symbol: "RK", color: "#6b3d33" },
  VEGAN: { symbol: "V", color: "#2D8300" },
  GOODS_FROM_FINLAND_BLUE_SWAN: {
    symbol: /* @__PURE__ */ o(l, { svgIcon: /* @__PURE__ */ o(i, {}), label: "" })
  },
  FINNISH_HEART_SYMBOL: {
    symbol: /* @__PURE__ */ o(l, { svgIcon: /* @__PURE__ */ o(e, {}), label: "" })
  },
  EU_ORGANIC_FARMING: {
    symbol: /* @__PURE__ */ o(l, { svgIcon: /* @__PURE__ */ o(_, {}), label: "" })
  },
  EU_ORGANIC_FARMING_LABEL: {
    symbol: /* @__PURE__ */ o(l, { svgIcon: /* @__PURE__ */ o(N, {}), label: "" })
  },
  EU_ECO_LABEL: {
    symbol: /* @__PURE__ */ o(l, { svgIcon: /* @__PURE__ */ o(b, {}), label: "" })
  },
  MADE_IN_FINLAND_FLAG_WITH_KEY: {
    symbol: /* @__PURE__ */ o(l, { svgIcon: /* @__PURE__ */ o(a, {}), label: "" })
  },
  RAINFOREST_ALLIANCE: {
    symbol: /* @__PURE__ */ o(m, {})
  },
  RAINFOREST_ALLIANCE_PEOPLE_NATURE: {
    symbol: /* @__PURE__ */ o(m, {})
  },
  PUHTAASTI_KOTIMAINEN: {
    symbol: /* @__PURE__ */ o(
      l,
      {
        svgIcon: /* @__PURE__ */ o(s, {}),
        label: ""
      }
    )
  },
  SVANEN: {
    symbol: /* @__PURE__ */ o(l, { svgIcon: /* @__PURE__ */ o(n, {}), label: "" })
  },
  FAIR_TRADE_MARK: {
    symbol: /* @__PURE__ */ o(l, { svgIcon: /* @__PURE__ */ o(c, {}), label: "" })
  }
};
export {
  m as RainforestAllianceSymbolWithInfo,
  U as supportedAttributes
};
